import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import Select from "antd/es/select";
import "antd/es/select/style/index.css";
import moment from 'moment';
import './styles.scss';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import _ from 'lodash';
import functionCommon from "../../core/common/function";

class TotalRecordForm extends Component {
    constructor() {
        super();
        let _currentYear = moment().format('YYYY');
        let _currentMonth = moment().format('MM');
        let _yearArr = [];
        for (let i = _currentYear - 9; i <= _currentYear; i++) {
            _yearArr.push(i);
        } 
        let monthArr = [{name: 'Jan', value: '01'}, 
                        {name: 'Feb', value: '02'}, 
                        {name: 'Mar', value: '03'}, 
                        {name: 'Apr', value: '04'}, 
                        {name: 'May', value: '05'}, 
                        {name: 'Jun', value: '06'}, 
                        {name: 'Jul', value: '07'}, 
                        {name: 'Aug', value: '08'}, 
                        {name: 'Sep', value: '09'}, 
                        {name: 'Oct', value: '10'}, 
                        {name: 'Nov', value: '11'}, 
                        {name: 'Dec', value: '12'}];
        this.state = {
            errInputMsg: {},
            monthArr: monthArr,
            currentYear: _currentYear,
            currentMonth: _currentMonth,
            yearArr: _yearArr,
            projectId: '',
            selectedValuesEmployee:[],    
            employeeId:['']
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError,
            currentYear: nextProps.currentValueYear,
            currentMonth : nextProps.currentValueMonth,
            projectId: parseInt(nextProps.projectId) || '',
        });
    }

    handleChangeSelect = (evt) => {
        this.props.changeSelect(evt);
    }

    handleChangeSelectProject = (value) => {
        this.props.changeSelectProject({_name: "projectId", _value: value});
    }

    handleChangeTotalRecordBy = (evt) => {
        this.props.changeTotalRecordBy(evt);
    }

    handleChangeDepartment = (value) => {
        this.setState({
            selectedValuesEmployee:[]
        });
        this.props.changeSelectEmployee({ _name: "employeeId", _value: [] })
        this.props.changeSelectDepartment({ _name: "departmentId", _value: value });
    }

    handleChangeEmployee = (value) => {
        this.setState({
            selectedValuesEmployee:value
        });
        this.props.changeSelectEmployee({ _name: "employeeId", _value: value })
    }

    render() {
        const { t, projectDataValue, totalRecordBy, dataDepartmentSlectBox, dataEmployeeSlectBox } = this.props;
        const { monthArr, currentYear, currentMonth, yearArr } = this.state;
        const { Option } = Select;
        const _projectData = _.map(projectDataValue, (state, index) => ({
            key: "project-" + index + 1,
            text: state['projectCode'] + ' - ' + state['projectName'],
            value: state['id'],
        }))
        _projectData.unshift({
            key: "project-0",
            text: 'All',
            value: '',
        })
        const _employeeList = _.map(dataEmployeeSlectBox, (item, index) => ({
            key: 'employee' + index + 1,
            text: item['employeeCode'] + ' - ' + item['employeeName'],
            value: item['employeeId']
        }))
        const _dataDepartmentSlectBox = _.map(dataDepartmentSlectBox, (item, index) => ({
            key: 'department' + index + 1,
            text: item['departmentName'],
            value: item['departmentId'],
        }))
        _dataDepartmentSlectBox.unshift({
            key: 'department-0',
            text: 'All',
            value: ' '
        })
        return (
            <div className="employee-form total-record-form">
                <Form>
                <div className="form-search">
                        <div className="form-search-left">
                            <label className="text">{t("labels.periodYear")}</label>
                            <select
                                name="year"
                                className="small-select year-select"
                                value={currentYear}
                                onChange={(e) => {
                                    this.handleChangeSelect(e);
                                }}
                            >
                                {yearArr.map((option, index) => {
                                    return (
                                        <option value={option} key={index}>
                                            {option}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="form-search-center">
                            <div className="select-label">
                                <label className="label-month">{t("labels.periodMonth")}</label>
                                <select
                                    name="month"
                                    className="small-select"
                                    value={currentMonth}
                                    onChange={(e) => {
                                        this.handleChangeSelect(e);
                                    }}
                                >
                                    <option value="">All</option>
                                    {monthArr.map((option, index) => {
                                        return (
                                            <option value={option.value} key={index}>
                                                {option.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            {this.state.errInputMsg["currentMonth"] ? (
                                <div className="error-message form-list-message error-periodMonth">
                                    {t(this.state.errInputMsg["currentMonth"])}
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="form-search-right">
                            <label>{t("labels.department")}</label>
                            <Select
                                className="department-select"
                                name="departmentId"
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                defaultValue={" "}
                                style={{ width: 300, height: 29 }}
                                onChange={this.handleChangeDepartment}
                            >
                                {_dataDepartmentSlectBox
                                    ? _dataDepartmentSlectBox.map((item, index) => {
                                          return (
                                              <Option value={item.value} label={item.text} key={item.key}>
                                                  {item.text}
                                              </Option>
                                          );
                                      })
                                    : ""}
                            </Select>
                        </div>
                    </div>
                    <Form.Group inline>
                        <label>{t("labels.projectName")}</label>
                        <Select
                            className="project-select"
                            name="projectId"
                            onChange={this.handleChangeSelectProject}
                            style={{ width: 317 }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={this.state.projectId}>
                            {_projectData.map((item, index)=> 
                                <Option value={item.value} key={item.key} label={item.text}>{item.text}</Option>
                            )}
                        </Select>
                        <div className="employee-select"><label style={{minWidth:"120px"}}>{t("labels.employee")}</label>
                            <Select mode="multiple"  name="employeeId"
                                showSearch
                                showArrow
                                allowClear
                                maxTagCount={2}
                                filterOption={functionCommon.filterEmployee}
                                value={this.state.selectedValuesEmployee}
                                style={{ width: 300}}
                                onChange={this.handleChangeEmployee}>
                                {
                                    (_employeeList)
                                        ? _employeeList.map((item, index) => {
                                            return (
                                                <Option value={item.value} label={item.text} key={item.key}>{item.text}</Option>
                                            )
                                        }) : ''}
                            </Select></div>
                    </Form.Group>
                    <Form.Group inline className="form-status">
                        <label>&nbsp;</label>
                        <div>
                            <Form.Field>
                                <input id="radio-by-date" type="radio" name="totalRecordBy"
                                    checked={totalRecordBy === "date"} value="date" onChange={e => { this.handleChangeTotalRecordBy(e) }}/>
                                <label htmlFor="radio-by-date">{t('labels.byDate')}</label>
                            </Form.Field>
                            <Form.Field>
                                <input id="radio-by-project" type="radio" name="totalRecordBy"
                                    checked={totalRecordBy === "project"} value="project" onChange={e => { this.handleChangeTotalRecordBy(e) }}/>
                                <label htmlFor="radio-by-project">{t('labels.byProject')}</label>
                            </Form.Field>
                        </div>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(TotalRecordForm);
